const CollapseLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M17.3352 18.5624L17.3352 0.562377L19.3352 0.562377L19.3352 18.5624L17.3352 18.5624ZM11.5072 8.56238L5.4352 2.49138L6.8492 1.07738L15.3352 9.56238L6.85021 18.0474L5.4352 16.6334L11.5052 10.5624L0.335205 10.5624L0.335205 8.56238L11.5072 8.56238Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default CollapseLine;
